import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type InfoIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const InfoIcon = ({
  size = 12,
  color,
  colorScheme = 'dark',
  className,
}: InfoIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Info'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 12 12'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='6' cy='6' r='5.25' stroke={resolvedColor} strokeWidth='1.5' />
      <path
        d='M6 5.5V8.5'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeWidth='1.5'
      />
      <circle cx='6' cy='3.5' fill={resolvedColor} r='0.75' />
    </svg>
  )
}
